<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
   <div>
       <div class="page-content">
           <div class="container-fluid">

               <div class="row">
                   <div class="col-12 mb-4">
                       <v-card>
                           <v-card-title>
                                   Gestion des roles de {{getname()}}
                               <v-spacer></v-spacer>
                               <v-text-field
                                       v-model="search"
                                       append-icon="mdi-magnify"
                                       label="Rechercher ..."
                                       single-line
                                       hide-details
                               ></v-text-field>
                           </v-card-title>
                           <v-data-table
                                   :headers="headers"
                                   :items="roleusers"
                                   :search="search"
                                   sort-by="name"
                                   class="elevation-1"
                                   :loading="roleusers==undefined" loading-text="Chargement en cours...">

                               <template v-slot:item.code="{ item }">
                                   <v-chip  dark>{{ item.code }}</v-chip>
                               </template>
                               <template v-slot:item.role_id="{item}">
                                   {{item.role_id.nom}}
                               </template>
                               <template v-slot:item.created_at="{item}">
                                   {{ getformatDate(item.created_at)}}
                               </template>
                               <template v-slot:top>
                                   <v-toolbar flat color="white">
                                       <v-spacer></v-spacer>
                                       <v-dialog v-model="dialog" max-width="500px">
                                           <template v-slot:activator="{ on }">
                                               <v-btn style="background: #2A3042;color: #fff" class="mb-2" v-on="on">Nouveau
                                               </v-btn>
                                           </template>
                                           <v-card>
                                               <v-card-title>
                                                   <span class="headline">{{ formTitle }}</span>
                                               </v-card-title>

                                               <v-card-text>


                                                   <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                       <v-alert v-if="errors" dense outlined
                                                                :type="(errors.update_error)?'error':'success'">
                                                           {{errors.operation}}
                                                       </v-alert>

                                                       <v-text-field v-if="submitting" color="primary" loading
                                                                     disabled></v-text-field>
                                                       <v-row>
                                                           <v-col cols="12" sm="6" md="12" >
                                                               <v-select :rules="roleRules" @change="roleChanged"   v-model="editedItem.role_id" item-text="nom" item-value="_id" :items="roles" label="Roles"  multiple
                                                               >
                                                                   <template v-slot:selection="{ item, index }">
                                                                       <v-chip v-if="index === 0">
                                                                           <span>{{ item.nom}}</span>
                                                                       </v-chip>
                                                                       <span
                                                                               v-if="index === 1"
                                                                               class="grey--text caption"
                                                                       >(+{{ editedItem.role_id.length - 1 }} others)</span>
                                                                   </template>

                                                               </v-select>
                                                           </v-col>

                                                          <!-- <v-col cols="6" sm="6" md="6" >
                                                               <v-select :rules="tierRules" @change="tierChanged"   v-model="editedItem.tier_id" item-text="nom" item-value="_id" :items="tiers" label="Tier"   persistent-hint>

                                                               </v-select>
                                                           </v-col>-->

                                                       </v-row>
                                                   </v-form>
                                               </v-card-text>

                                               <v-card-actions>
                                                   <v-spacer></v-spacer>
                                                   <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                                                   <v-btn color="blue darken-1"  :disabled="!valid" text @click="save">Sauvegarder</v-btn>
                                               </v-card-actions>
                                           </v-card>
                                       </v-dialog>
                                   </v-toolbar>
                               </template>
                               <template v-slot:item.actions="{ item }">
                                   <v-icon small @click="deleteItem(item)">
                                       mdi-delete
                                   </v-icon>
                               </template>
                               <template v-slot:no-data>
                                   <v-btn color="default" @click="initialize">Actualiser</v-btn>
                               </template>
                           </v-data-table>
                       </v-card>
                   </div>
               </div>
               <v-snackbar
                       v-model="snackbar"
                       timeout="2000"
               >
                   {{ textSnack }}

                   <template v-slot:action="{ attrs }">
                       <v-btn
                               color="blue"
                               text
                               v-bind="attrs"
                               @click="snackbar = false"
                       >
                           Fermer
                       </v-btn>
                   </template>
               </v-snackbar>

           </div> <!-- container-fluid -->
       </div>
       <!-- End Page-content -->

   </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    export default {
        name: "RoleUser",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                roleHasChanged: false,
                dialog: '',
                assureurHasChanged:false,
                tierHasChanged:false,
                id: undefined,
                snackbar: false,
                textSnack: '',
                headers: [

                    {text: 'Role', value: 'role_id'},
                    {text: 'Ajouté le:', value: 'created_at'},

                    {text: 'Actions', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                roleRules: [
                    v => !!v || 'Role requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                tierRules: [
                    v => !!v || 'Tier requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],


            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouveau " : "Mise à jour"
            }
            ,
            ...mapState('roleusers/', ['roleusers']),
            ...mapState('roles/', ['roles'])



        }
        ,
        mounted() {
             this.$store.dispatch('roles/getnot',this.$route.params.id).then(response => {
               window.console.log('notroles', response)
           })
          let user = JSON.parse(localStorage.getItem("user"));
            console.log("User local2");
            console.log(user);
            this.$store.dispatch('roleusers/get',this.$route.params.id).then(response => {
                window.console.log('roleusers', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,
            assureurChanged(){
                this.assureurHasChanged = true;
            },
            tierChanged(){
                this.tierHasChanged = true;
            },
            editItem(item) {
                this.editedIndex = this.types.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            roleChanged(){
                this.roleHasChanged = true;
            },

            getname(){
                for (let i=0;i< this.roles.length;i++){
                    let role= this.roles[i];
                    if(role.user_id===this.$route.params.id){
                        return role.name
                    }
                }
            }
            ,
            getformatDate(value){
                if (value) {
                    return Intl.DateTimeFormat('en-US',{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"}).format(new Date(value));
                }
            },

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('roleusers/delete', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                        });
                        this.$store.dispatch('roleusers/get',this.$route.params.id).then(response => {
                            window.console.log('roleusers', response)
                        });

                    }
                })
            },
            close() {
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
                this.dialog = false;

            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("user_id",this.$route.params.id);
                if ( this.roleHasChanged)
                    data.append("role_id",JSON.stringify(this.editedItem.role_id));
                let mineroute = 'roleusers/set';
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(){
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>